<ds-form-field [ngClass]="[styleClass]">
    @if (label) {
    <label
        ds-label
        [for]="inputId"
        >{{ label | translate }}
    </label>
    }
    <ds-datepicker [config]="config">
        <input
            ds-date
            class="text-label"
            [id]="inputId"
            [(ngModel)]="value"
            [disabled]="isDisabled"
            [placeholder]="placeholder"
            [required]="!showOptionalLabel"
            [title]="value ? (value | date) : ''"
            (ngModelChange)="valueChanged.emit($event)" />
    </ds-datepicker>
</ds-form-field>
